import { i18n } from '@shared/i18n';

import { PropertyService } from '@modules/property/property-service';

import Errors from '@shared/error/errors';
import LinkModel from '@shared/settings/link-model';

const requirementsConfig = {
    property: {
        icon: 'icon-home',
        title: i18n('entities.property.requirementSteps.steps.property.title'),
        link: new LinkModel(i18n('entities.property.requirementSteps.steps.property.linkCaption'), null),
        onClick() {
          this.$router.push({
            name: 'propertyEdit',
            params: {
              id: this.currentManage.property.id,
            },
          });
        },
    },
    profile: {
        icon: 'icon-player',
        title: i18n('entities.property.requirementSteps.steps.profile.title'),
        link: new LinkModel(i18n('entities.property.requirementSteps.steps.profile.linkCaption'), null),
        onClick() {
          this.$router.push({
            name: 'editProfile'
          });
        },
    },
};

export default {
  namespaced: true,

  state: {
    loading: false,
    steps: {},
  },

  getters: {
    loading: state => state.loading,
    steps: state => state.steps,
    stepsArray: state => Object.values(state.steps),
    areRequirementsFullfiled: state => ({
      all: !!Object.values(state.steps).length && Object.values(state.steps).every(({ done }) => done)
    }),
  },

  mutations: {
    FETCH_STARTED(state) {
      state.loading = true;
    },

    FETCH_SUCCESS(state, { steps }) {
      state.loading = false;
      state.steps = steps;
    },

    FETCH_ERROR(state) {
        state.loading = false;
        state.steps = [];
    },
  },

  actions: {
    async doFetch(
      { commit },
      { propertyId, userId }
    ) {
      try {
        commit('FETCH_STARTED');

        const response = await PropertyService.requirementSteps(propertyId, userId);
        const steps = Object.assign({}, requirementsConfig);
        response.steps.forEach(({ key, done, active }) => {
          steps[key].done = done;
          steps[key].active = active;
        });

        commit('FETCH_SUCCESS', { steps });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },
    doReset({ commit }) {
      commit('FETCH_ERROR');
    },
  },
};
